import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import _ from "lodash";
import moment from "moment";
import DOMPurify from 'dompurify';
import Parser from 'html-react-parser';

import "./../index.css"

import { Dialog } from "primereact/dialog";
import { ConfirmPopup } from "primereact/confirmpopup";

import Menu from "../../../helpers/Menu";
import { Button } from "../../../helpers";
import Stepper from "../../../helpers/Stepper";
import Tooltip from "../../../helpers/Tooltip"

import Loading from "../../../common/Loading";
import SendEmail from "../../../common/SendEmail";
import RemarksDialog from "../../../common/RemarksDialog";
import DocumentView from "../../../common/DocumentView";
import PMUserName from "../../../common/PMUserName";

import RaisePOModal from "./RaisePOModal";
import ExtendValidityDialog from "./ExtendValidityDialog";
import QuoteClosureReasonModal from "./QuoteClosureReasonModal";
import MaterialConfirmDailogModal from "./MaterialConfirmDailog";
import AddrAndGSTINConfirmDialog from "./AddrAndGSTINConfirmDailog";
import ConversionProbabilityDialog from "./ConversionProbabilityDailog";
import NewApprovalsDisplay from "../../AuditProduct/components/NewApprovalsDisplay";

import { sendEmail } from "../../../services/api/sendEmail";
import { insertBuyerPO } from "../../../services/api/buyerPO";
import { getDocCopyByDocNo } from "../../../services/api/docCopy";
import { cancelBuyerQuote } from "../../../services/api/buyerQuote";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchApprovalSecondary, fetchApprovalTypes, fetchApprovals, fetchBuyerQuoteClosureReasonList, fetchCompanyCreditPeriods, fetchCountries, fetchMaterialBrands, fetchMaterialCategories, fetchMaterialUoms, fetchPinCodes, fetchStates, fetchStatus } from "../../../services/redux/reducers/commonThunk";

import downloadFile from "../../../utils/DownloadFile";
import { calculateBuyerPO, calculateQuoteApprovals, getApprovalRequestStatusDetails, getApprovalStatus, getDateString, getPaymentTermsString, getProductName, getProductQty, getProductSpecification, isMobile, numberConversion, round, getFullName } from "../../../utils";

import { DATE_FORMAT } from "../../../constants";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
import CopyToClipboard from "../../../common/CopyToClipboard";
import { confirmDialog } from "primereact/confirmdialog";
import QtyMultiplierConfirmDialog from "./QtyMultiplierConfirmDialog";


const BuyerQuoteView = (props) => {
    const {
        displayTable, 
        buyerQuoteId,
        buyerQuote,
        setBuyerQuote,
        buyerQuoteItems,
        buyerReq,
        buyerReqItems,
        buyerPO,
        buyerPOItems,
        sellerReqItems,
        buyerRateContracts,
        materialDetails,
        buyerBillAddrDetails,
        buyerShipAddrDetails,
        setBuyerShipAddressDetails,
        pmCompanyBillAddrDetails,
        selectedReq,
        getBuyerQuotes,
        approvalInstances,
        setApprovalInstances,
        isAllItemsPODone,
        raisedBuyerQuoteItems,
        setraisedBuyerQuoteItems,
        selectedBuyerQuoteItems,
        setSelectedBuyerQuoteItems,
        initialRaisedBuyerQuoteItems,
        selectedBuyerBillAddrId,
        setSelectedBuyerBillAddrId,
        selectedBuyerShipAddrId,
        setSelectedBuyerShipAddrId,
        documentHTML,
        buyerQuotePDFURL,
        setBuyerQuotePDFURL,
        isLoading,
        setIsLoading,
        visiblePageLoading,
        setVisiblePageLoading,
        buyerBranchUsers,
        buyerCompanyDetails
    } = props

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const actionMenu = useRef(null)
    const documentRef = useRef(null)

    const [visibleRaisePo, setVisibleRaisePO] = useState(false)
    const [visibleApprovals, setVisibleApprovals] = useState(false)
    const [isLoadingVisible, setIsLoadingVisible] = useState(false)
    const [isEmailDialogVisible, setIsEmialDialogVisible] = useState(false)
    const [isReasonDialogVisible, setIsReasonDialogVisible] = useState(false)
    const [isExtendValidityDialogVisible, setIsExtendValidityDialogVisible] = useState(false)

    const [PDFDownloadLoading, setPDFDownloadLoading] = useState(false)
 
    const [raisePOData, setRaisePOData] = useState(null)

    const [requiredApprovals, setRequiredApprovals] = useState([])
    const [approvalRequestStatusDetails, setApprovalRequestStatusDetails] = useState([])

    const [isClosureReasonModalVisible, setIsClosureReasonModalVisible] = useState(false)
    const [isConversionProbabilityVisible, setIsConversionProbabilityVisible] = useState(false)

    const [showConfirmationStepper, setShowConfirmationStepper] = useState(false)
    const [materialDeclaration, setMaterialDeclaration] = useState(false)
    const [qtyMultiplierDeclaration, setQtyMultiplierDeclarataion] = useState(false)
    const [addressAndGSTINDeclaration, setAddressAndGSTINDeclaration] = useState({})

    const companyCreditPeriods = useSelector((state) => state.common.companyCreditPeriods)
    const pmUserDetails = useSelector(state => state.userDetails.userNameDetails)
    const usersData = useSelector(state => state.userDetails)
    const statusData = useSelector((state) => state.common.status)
    const brandData = useSelector((state) => state.common.materialBrands)
    const approvals = useSelector((state) => state.common.approvals)
    const approvalTypes = useSelector((state) => state.common.approvalTypes)
    const materialCategories = useSelector((state) => state.common.materialCategories)
    const materialUOMs = useSelector((state) => state.common.materialUOMs)
    const stateList = useSelector((state) => state.common.states)
    const countriesData = useSelector((state) => state.common.countries)
    const pinCodes = useSelector(state => state.common.pinCodes)
    const approvalSecondary = useSelector((state) => state.common.approvalSecondary)

    const isMobileDevice = isMobile() 

    let isPassRequirement = false
    if (buyerReq.pmBranchId === 24716) {
        isPassRequirement = true
    }

    let notItemTerms = ["courier", "logistics", "transport", "freight"]

    const pmCompanyConfig = getPMCompanyConfig(buyerQuote.pmCompanyId)
    let { currencyShortName, numberLocale } = pmCompanyConfig

    let quoteValidUpTo = ""
    if(buyerQuote.validUpto){
        quoteValidUpTo = moment(buyerQuote?.validUpto).format(DATE_FORMAT)
    }

    const paymentTermsObj = getPaymentTermsString(buyerQuote.paymentTerms, companyCreditPeriods)
    const maxLeadTimeBuyerQuoteItem = _.max(buyerQuoteItems, "leadTime")
    const maxDeliveryTime = maxLeadTimeBuyerQuoteItem?.leadTime

    let quotationApprovals = useMemo(() => {
        return approvals?.filter(eachApproval => pmCompanyConfig.quotationApprovalTypeIds.includes(eachApproval.approvalTypeId))
    }, [approvals])

    const relatedBuyerBillAddrDetails = buyerBillAddrDetails?.filter(eachBillAddr => eachBillAddr.billAddrId === buyerReq.billAddrId)

    let userEmail = "orders@procmart.com"
    let clientId = ""
    let refreshToken = ""
    let clientSecret = ""
    if (isPassRequirement && buyerCompanyDetails && buyerCompanyDetails.tags?.isPASSEnabled && buyerCompanyDetails.tags?.PASSEmailCredentials?.length && buyerBranchUsers.length) {
        const passEmailCredentials = buyerCompanyDetails.tags.PASSEmailCredentials.find(eachPassCredential => {
            const relatedBuyerClientDetails = buyerBranchUsers.find(eachBuyerDetails => eachPassCredential.emailId === eachBuyerDetails.emailId)
            if (relatedBuyerClientDetails) {
                return true
            }
            return false
        })

        if (passEmailCredentials) {
            userEmail = passEmailCredentials.emailId
            clientId = passEmailCredentials.clientId
            refreshToken = passEmailCredentials.refreshToken
            clientSecret = passEmailCredentials.clientSecret
        }
    }

    let emailDetailsObj = {
        to: relatedBuyerBillAddrDetails?.[0]?.email,
        from: userEmail,
        kam: pmUserDetails?.emailId,
        subject: `Quotation ${relatedBuyerBillAddrDetails?.[0]?.companyName} - ${moment(new Date()).format(DATE_FORMAT)} (${buyerQuote?.docNo})`,
        message: `
            <div>
                Dear Sir/Madam,<br/><br/>
                Greetings From ProcMart !!!!<br/><br/>
                Thank you for your valuable inquiry, please find the attached quotation for your requirement.<br/>
                Hope the offer is inline to your requirement, we are looking forward to receive your valued order and we request you to please release your order as per the enclosed quotation.<br/>
                Please note the following points - <br/>
                <b>Delivery Period</b> : ${maxDeliveryTime} Days<br/>
                <b>Quotation Validity</b> : ${quoteValidUpTo}<br/>
                <b>Payment Terms</b> : ${paymentTermsObj?.paymentTermsString} <br/><br/>
                For any further clarifications, you can contact us at below-mentioned details, thanking you and assuring you of our best services at all times. <br/>
                ${pmUserDetails?.firstName} ${pmUserDetails?.lastName} <br/> ${pmUserDetails?.phoneNumber} <br/> ${pmUserDetails?.emailId} <br/><br/><br/>
                
                <h3>Please do not reply to this email, replies to this message are routed to an unmonitored mailbox.
                If you have any questions please contact ${pmUserDetails?.firstName} ${pmUserDetails?.lastName} (${pmUserDetails?.phoneNumber})</h3>
            </div>
        `,
        attachments: [{file_name: "Quotation.pdf", url: buyerQuotePDFURL ? buyerQuotePDFURL : "", data_uri: ""}],
        clientId,
        refreshToken,
        clientSecret
    }

    const activeBuyerPOs = buyerPO?.filter(each => each.buyerQuoteId === buyerQuote?.buyerQuoteId && each.statusId === 3)

    let isQuoteExpired = false
    if (buyerQuote.validUpto) {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
    
        const validUptoDate = new Date(buyerQuote.validUpto)
        validUptoDate.setHours(0, 0, 0, 0)
    
        if (today > validUptoDate) {
            isQuoteExpired = true
        }
    }

    let {
        notRequestedApprovalExists, 
        pendingApprovalsExist, 
        allApprovalsApproved
    } = getApprovalStatus(approvalRequestStatusDetails)
    
    if(activeBuyerPOs.length){
        pendingApprovalsExist = false
        allApprovalsApproved = true
    }
    
    const actionMenuItems = [
        {
            label: 'View Doc',
            visible: displayTable ? true : false,
            command: () => {
                window.open(`/buyer/quotation/${buyerQuote.buyerQuoteId}`, "_blank")
            }
        },
        {
            label: 'Edit Quote',
            permissions: [217],
            command: () => {
                navigate(`/buyerQuote/${buyerQuoteId}`)
            },
            disabled:  buyerQuote?.statusId === 6
        },
        {
            label: "Raise PO",        
            permissions: [8],
            disabled: isQuoteExpired || buyerQuote?.statusId === 6 || pendingApprovalsExist, // buyerQuote?.statusId !== 1 ||
            // command: () => {setVisibleRaisePO(true)},
            command: () => 
                confirmDialog({
                    message: getConfirmMessageBody(),
                    header: 'Confirmation',
                    icon: 'pi pi-exclamation-triangle',
                    accept: async () => setVisibleRaisePO(true)
                }),
            id: "quoteExpirationRaisePOTooltip"
        },
        {
            label: 'Extend Validity',
            permissions: [9],
            hide: buyerQuote?.statusId !== 1,
            disabled: !isQuoteExpired || pendingApprovalsExist,
            command: () => {handleExtendValidity()}
        },
        {
            label: PDFDownloadLoading ? "Loading..." : 'Download Quotation',
            disabled: PDFDownloadLoading || pendingApprovalsExist || isQuoteExpired,
            permissions: [10],
            command: () => {downloadBuyerQuotePDF()},
            id: "quoteExpirationDownloadQuoteTooltip"
        },
        {
            label: 'Send Email',
            permissions: [10],
            command: () => {setIsEmialDialogVisible(true)},
            disabled: buyerQuote?.statusId !== 1 || pendingApprovalsExist || isQuoteExpired,
        },
        {
            label: 'Cancel Buyer Quotation',
            command: () => {
                if (buyerQuote?.statusId === 1){
                    setIsReasonDialogVisible(true)
                }
                else{
                    dispatch(raiseToast({severity:'warn', detail:'Buyer Quote has been Cancelled Already.', life: 3000}))  
                }
            },
            className: "cancel-btn",
            disabled: activeBuyerPOs.length > 0 || buyerQuote?.statusId === 6,
            permissions: [11]
        },
        {
            label: 'Quote Lost Reason',
            command: () => {
                setIsClosureReasonModalVisible(true)
            },
            permissions: [187]
            // className: "cancel-btn",
        },
        {
            label: 'Conversion Probability',
            command: () => {
                setIsConversionProbabilityVisible(true)
            },
            permissions: [188]
        },
        {
            label: "Regenerate Document",
            className: "",
            command: () => regenerateDocCopy(),            
            permissions: [102],
            visible: true,
            disabled: isLoading || PDFDownloadLoading
        },
    ]

    const regenerateDocCopy = async () => {
        if(!window.confirm("Confirm to regenerate document")){
            return
        }

        setIsLoading(true)

        const createNewDocCopy = true
        const docCopyRes = await getDocCopyByDocNo(buyerQuote.docNo, null, createNewDocCopy)

        if(docCopyRes.failure){
            dispatch(raiseToast({severity:'error', detail: docCopyRes.data.error, life: 3000}))
        }else{
            setBuyerQuotePDFURL(docCopyRes?.docLocation)
        }

        setIsLoading(false)
    }

    useEffect(()=> {
        dispatch(fetchBuyerQuoteClosureReasonList(true))
        dispatch(fetchMaterialCategories())
        dispatch(fetchMaterialUoms())
        dispatch(fetchApprovalTypes())
        dispatch(fetchApprovals())
        dispatch(fetchMaterialBrands())
        dispatch(fetchStatus())
        dispatch(fetchCompanyCreditPeriods())
        dispatch(fetchStates())
        dispatch(fetchPinCodes())
        dispatch(fetchCountries())
        dispatch(fetchApprovalSecondary())
    }, [])

    useEffect(() => {
        if(buyerQuote && buyerQuoteItems.length > 0){
            calculateApprovalsNew()
        }
    }, [buyerQuote, buyerQuoteItems, approvalInstances])

    const calculateApprovalsNew = () => {
        const updatedByUserDetails = usersData.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === buyerQuote.updatedBy)
        const updatedRequiredApprovals = calculateQuoteApprovals({buyerReq, buyerReqItems, quotationApprovals, buyerQuote, buyerQuoteItems, updatedByUserDetails})
        setRequiredApprovals(updatedRequiredApprovals)

        const pmBranchId = buyerQuote.pmBranchId
        const approvalRequestStatusDetails = getApprovalRequestStatusDetails({updatedRequiredApprovals, approvalInstances, approvals, pmBranchId})

        let totalBuyerQuoteAmount = parseFloat(buyerQuote?.bQuotTotalItemAmountBeforeTax)
        let totalSellerQuoteAmount = 0
        let totalSellerQuoteAmountWithTax = 0

        buyerQuoteItems?.map(eachBuyerQuoteItem => {
            const relatedSellerReqItem = sellerReqItems?.find(eachSellerReqItem => eachSellerReqItem?.sellerReqItemId === eachBuyerQuoteItem?.sellerReqItemId)
            if (relatedSellerReqItem?.statusId === 1){
                let sellerAmountBeforeTax = eachBuyerQuoteItem?.bQuotSellerQty * eachBuyerQuoteItem?.bQuotSellerPrice
                let sellerAmountTax = sellerAmountBeforeTax * relatedSellerReqItem?.quotGSTRate * 0.01
                let sellerAmountWithTax = sellerAmountBeforeTax + sellerAmountTax
                totalSellerQuoteAmount += sellerAmountBeforeTax
                totalSellerQuoteAmountWithTax += sellerAmountWithTax
            }
        })

        let marginPercentage = ((parseFloat(totalBuyerQuoteAmount) - totalSellerQuoteAmount)/totalBuyerQuoteAmount) * 100

        totalBuyerQuoteAmount = numberConversion(totalBuyerQuoteAmount, numberLocale)
        totalSellerQuoteAmount = numberConversion(totalSellerQuoteAmount, numberLocale)

        let isQuoteLoss = buyerQuote.bQuotTotalItemAmountWithTax < totalSellerQuoteAmountWithTax

        let prefillText = ""
        let quoteLossPrefillText = ""
        if (totalSellerQuoteAmount){
            prefillText += `PO Purchase: ${currencyShortName}.${totalSellerQuoteAmountWithTax}, `
            if(isQuoteLoss){
                quoteLossPrefillText += `Loss Amount: ${currencyShortName}.${numberConversion(totalSellerQuoteAmountWithTax - buyerQuote.bQuotTotalItemAmountWithTax)}, `
            }
        }
        if (totalBuyerQuoteAmount){
            prefillText += `Quoted Amount: ${currencyShortName}.${buyerQuote?.bQuotTotalItemAmountWithTax}, `
            if(isQuoteLoss){
                quoteLossPrefillText += `Quote Amount: ${currencyShortName}. ${numberConversion(buyerQuote.bQuotTotalItemAmountWithTax)}, `
            }
        }
        if (marginPercentage){
            prefillText += `Margin: ${round(marginPercentage)}% `
            if(isQuoteLoss){
                quoteLossPrefillText += `Loss: ${Math.abs(round(marginPercentage, 0))}%. `
            }
        }

        let updatedApprovalRequestStatusDetails = approvalRequestStatusDetails?.map(eachRequestDetail => {
            if (eachRequestDetail?.approvalTypeId === 1){
                return {...eachRequestDetail, remarks: prefillText, prefillText: prefillText}
            }
            else if(eachRequestDetail.approvalTypeId === 2){
                return {...eachRequestDetail, remarks: quoteLossPrefillText, prefillText: quoteLossPrefillText}
            }
            return eachRequestDetail
        })
        setApprovalRequestStatusDetails(updatedApprovalRequestStatusDetails)
    }

    const getConfirmMessageBody = () => {
        const relatedState = stateList.find(eachState => eachState.stateId === parseInt(pmCompanyBillAddrDetails.stateId))
        let stateName = ""
        if (relatedState){
            stateName = relatedState.stateName
        }

        return (
            <>
                {`You have selected the state '${stateName}' with the `} <br />
                {`GSTIN '${pmCompanyBillAddrDetails.gstinCode}'.`} <br />
                {"Please confirm that the details are correct before proceeding."}
            </>
        )
    }

    const handleCancelBuyerQuote = async (value) => {
        const activeBuyerPOs = buyerPO.filter(each => each.buyerQuoteId === buyerQuote.buyerQuoteId && each.statusId === 3)
        if(activeBuyerPOs.length === 0){
            if(window.confirm("Are you sure you want to cancel this buyer quote?")){
                setVisiblePageLoading(true)
                setIsReasonDialogVisible(false)
                const response = await cancelBuyerQuote(buyerQuoteId, {cancellationReason: value})
                if (response.failure){
                    setVisiblePageLoading(false)
                    return dispatch(raiseToast({severity:'error', detail: response.data.error, summary: response.data.error, life: 3000}))
                }else {
                    setVisiblePageLoading(false)
                    dispatch(raiseToast({severity:'warn', detail:'Buyer Quote has been Marked as Cancelled.', life: 3000}))  
                }
                getBuyerQuotes()
            }
        }else{
            return dispatch(raiseToast({severity:'error', detail:'There is an active Buyer Purchase order', life: 3000}))  
        }
        setIsReasonDialogVisible(false)
    }

    const handleExtendValidity = async() => {
        setIsExtendValidityDialogVisible(true)
    }

    const downloadBuyerQuotePDF = async () => {
        if(buyerQuotePDFURL){
            downloadFile(buyerQuotePDFURL, `Quote-${buyerQuote.docNo}.pdf`)
        } else {
            setPDFDownloadLoading(true)
            const docCopyRes = await getDocCopyByDocNo(buyerQuote.docNo, true)
            
            if(docCopyRes?.failure){
                setPDFDownloadLoading(false)
                return dispatch(raiseToast({severity:'error', summary: "Buyer Quotation Document", detail:docCopyRes.data.error, life: 3000}))
            } else if(!docCopyRes?.docLocation){
                setPDFDownloadLoading(false)
                return dispatch(raiseToast({severity:'error', summary: "Buyer Quotaion Document", detail: "Buyer Quotation document was not found.", life: 3000}))
            }
            downloadFile(docCopyRes?.docLocation, `Quote-${buyerQuote.docNo}.pdf`)
            setBuyerQuotePDFURL(docCopyRes?.docLocation)
            setPDFDownloadLoading(false)
        }
    }

    const handleBuyerPOItemChange = (buyerQuoteItemId, name, value) => {
        const updatedBuyerPOItems = raisedBuyerQuoteItems.map(eachBuyerPOItem => {
            if(value.length > 1 && value[0] === "0"){
                value = value.substring(1)
            }
            if (eachBuyerPOItem.buyerQuoteItemId === buyerQuoteItemId){
                return { ...eachBuyerPOItem, [name] : value === "" ? 0 : value }
            }
            return eachBuyerPOItem
            
        })
        setraisedBuyerQuoteItems([...updatedBuyerPOItems])
    }

    const handleCheckBoxClick = (e) => {
        let buyerQuoteItemIds = raisedBuyerQuoteItems.map(eachBuyerPOItem => eachBuyerPOItem.buyerQuoteItemId)
        if (e.checked){
            setSelectedBuyerQuoteItems(buyerQuoteItemIds)
        } else {
            setSelectedBuyerQuoteItems([])
        }
    }

    const handleSelectBuyerQuoteItems = (buyerQuoteItemId) => {
        if(selectedBuyerQuoteItems.includes(buyerQuoteItemId)){
            const updatedBuyerQuoteItems = selectedBuyerQuoteItems.filter(eachBuyerQuoteItemId => eachBuyerQuoteItemId !== buyerQuoteItemId)
            setSelectedBuyerQuoteItems(updatedBuyerQuoteItems)
        } else {
            const updatedBuyerQuoteItems = [...selectedBuyerQuoteItems, buyerQuoteItemId]
            setSelectedBuyerQuoteItems(updatedBuyerQuoteItems)
        }
    }

    const handleRaisePO = async () => {
        const newBuyerQuoteItems = []
        const activeRoleId = usersData?.activeRoleId
        const relatedUserCompany = usersData?.rolesList?.find(eachRole => eachRole?.userRoleId === activeRoleId)

        raisedBuyerQuoteItems.map(eachBuyerQuoteItem => {
            if (selectedBuyerQuoteItems.includes(eachBuyerQuoteItem.buyerQuoteItemId) && eachBuyerQuoteItem?.bPOQty > 0){
                newBuyerQuoteItems.push({
                    buyerReqId: eachBuyerQuoteItem.buyerReqId,
                    buyerReqItemId: eachBuyerQuoteItem.buyerReqItemId,
                    buyerQuoteItemId : eachBuyerQuoteItem.buyerQuoteItemId,
                    fileNo: eachBuyerQuoteItem.fileNo,
                    docNo: eachBuyerQuoteItem.docNo,
                    printedDesc: eachBuyerQuoteItem.printedDesc,
                    materialId: eachBuyerQuoteItem.materialId,
                    companyERPCode: eachBuyerQuoteItem.companyERPCode,
                    bPOQty: parseFloat(eachBuyerQuoteItem.bPOQty),
                    bPOListPrice: eachBuyerQuoteItem.bQuotListPrice,
                    bPOUnitPrice: eachBuyerQuoteItem.bQuotUnitPrice,
                    bPOGSTRate: eachBuyerQuoteItem.bQuoteGSTRate,
                    bPOHSNCode: eachBuyerQuoteItem.bQuotHSNCode,
                    bPOItemAmountBeforeTax: eachBuyerQuoteItem.bQuoteItemAmountBeforeTax,
                    bPOItemAmountWithTax: eachBuyerQuoteItem.bQuoteItemAmountWithTax,
                    leadTime: eachBuyerQuoteItem.leadTime,
                    buyerRateContractId: eachBuyerQuoteItem.buyerRateContractId,
                    shipsFromAddrId: eachBuyerQuoteItem.shipsFromAddrId,
                    pmCompanyId: relatedUserCompany?.pmCompanyId,
                    currency: eachBuyerQuoteItem.currency,
                    currencyRate: eachBuyerQuoteItem.currencyRate,
                    createdBy: usersData?.userId, 
                    updatedBy: usersData?.userId,
                    companyQtyMultiplier: eachBuyerQuoteItem.companyQtyMultiplier
                })
            }
        })
        
        let isAllAreNotProducts = newBuyerQuoteItems?.some(eachBuyerQuoteItem => {
            const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerQuoteItem?.materialId)
            let productName = relatedMaterial?.companyProdName ? relatedMaterial?.companyProdName : relatedMaterial?.productName
            let productSpecification = relatedMaterial?.companyProdName ? relatedMaterial?.companyProdName : relatedMaterial?.productName
            let isProductIncluded = notItemTerms.includes(productName.toLowerCase()) || notItemTerms.includes(productSpecification.toLowerCase())
            return isProductIncluded
        })

        if (!newBuyerQuoteItems.length > 0 ){
            dispatch(raiseToast({severity:'error', detail: "Select the Requirements and Enter the Quantity", life: 3000}))
        } else if (!selectedBuyerBillAddrId){
            dispatch(raiseToast({severity:'warn', detail: "Select Billing Address", life: 3000}))
        } else if (!selectedBuyerShipAddrId){
            dispatch(raiseToast({severity:'warn', detail: "Select Shipping Address", life: 3000}))
        }
        else {
            const relatedBuyerBillAddr = buyerBillAddrDetails?.find(eachBuyerBillAddr => eachBuyerBillAddr?.billAddrId === selectedBuyerBillAddrId)
            let isIGST = relatedBuyerBillAddr?.stateId === pmCompanyBillAddrDetails?.stateId ? false : true

            if(pmCompanyBillAddrDetails.gstinCode && !["URP", "URD"].includes(pmCompanyBillAddrDetails.gstinCode) && relatedBuyerBillAddr.gstinCode && !["URP", "URD"].includes(relatedBuyerBillAddr.gstinCode)){
                isIGST = parseInt(pmCompanyBillAddrDetails.gstinCode.slice(0, 2)) !== parseInt(relatedBuyerBillAddr.gstinCode.slice(0, 2))
            }

            let updatedClientMaterials = []
            let updatedClientQtyMultiplierMaterials = []
            raisedBuyerQuoteItems.map(eachBuyerQuoteItem => {
                if (selectedBuyerQuoteItems.includes(eachBuyerQuoteItem.buyerQuoteItemId) && eachBuyerQuoteItem?.bPOQty > 0){
                    const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.buyerReqItemId === eachBuyerQuoteItem?.buyerReqItemId)
                    const relatedUOM = materialUOMs?.find(eachUOM => eachUOM?.materialUOMId === eachBuyerQuoteItem?.companyERPUOMId)
                    const relatedRateContract = buyerRateContracts?.find(eachBuyerRateContract => eachBuyerRateContract?.companyERPCodeMapId === eachBuyerQuoteItem?.companyERPCodeMapId)
                    if (!relatedRateContract){
                        if (relatedMaterial?.companyERPCode !== eachBuyerQuoteItem?.companyERPCode || relatedMaterial?.companyProdName !== eachBuyerQuoteItem?.companyProdName || relatedMaterial?.companyProdSpec !== eachBuyerQuoteItem?.companyProdSpec || (!relatedRateContract && relatedMaterial?.companyERPUOM !== relatedUOM?.UOM) || (parseFloat(relatedMaterial?.companyQtyMultiplier) !== parseFloat(eachBuyerQuoteItem?.companyQtyMultiplier) && ![1, null].includes(eachBuyerQuoteItem.companyQtyMultiplier))){
                            let updatedMaterial = {
                                companyERPCode : eachBuyerQuoteItem?.companyERPCode,
                                companyERPCodeMapId: eachBuyerQuoteItem?.companyERPCodeMapId,
                                companyProdName: eachBuyerQuoteItem?.companyProdName,
                                companyProdSpec: eachBuyerQuoteItem?.companyProdSpec,
                                companyERPCategory: eachBuyerQuoteItem?.companyERPCategory,
                                companyQtyMultiplier: eachBuyerQuoteItem?.companyQtyMultiplier,
                                companyERPUOM: relatedUOM?.UOM,
                                companyId: buyerQuote?.companyId,
                                materialId: relatedMaterial?.materialId,
                                companyHSNOverride: relatedMaterial.companyHSNOverride,
                                companyGSTOverride: relatedMaterial.companyGSTOverride
                                // updatedAt: new Date(),
                                // updatedBy: usersData?.userId
                            }
                            updatedClientMaterials.push(updatedMaterial)
                        }
                    }
                    //else if (relatedMaterial?.companyQtyMultiplier !== eachBuyerQuoteItem?.companyQtyMultiplier){
                    //     let updatedMaterial = {
                    //         companyERPCode : eachBuyerQuoteItem?.companyERPCode,
                    //         companyERPCodeMapId: eachBuyerQuoteItem?.companyERPCodeMapId,
                    //         companyProdName: eachBuyerQuoteItem?.companyProdName,
                    //         cDo you want to continue to RaiseompanyProdSpec: eachBuyerQuoteItem?.companyProdSpec,
                    //         companyERPCategory: eachBuyerQuoteItem?.companyERPCategory,
                    //         companyQtyMultiplier: eachBuyerQuoteItem?.companyQtyMultiplier,
                    //         companyERPUOM: relatedUOM?.companyERPUOM,
                    //         companyId: buyerQuote?.companyId,
                    //         materialId: relatedMaterial?.materialId,
                    //         updatedAt: new Date(),
                    //         updatedBy: usersData?.userId
                    //     }
                    //     updatedClientQtyMultiplierMaterials.push(updatedMaterial)
                    // }
                }
            })

            let buyerPOData = {
                buyerReqId : buyerQuote.buyerReqId, 
                buyerQuoteId: buyerQuote.buyerQuoteId,
                fileNo: buyerQuote.fileNo,
                docNo: buyerQuote.docNo,
                parentDocNo: buyerQuote.docNo,
                companyId: buyerQuote.companyId,
                branchId: buyerQuote.branchId,
                userId: buyerQuote.userId,
                GSTType: isIGST ? "I" : "CS",
                bPOLogisticsBeforeTax: buyerQuote.bQuotLogisticsBeforeTax,
                bPOLogisticsGSTRate: buyerQuote.bQuotLogisticsGSTRate,
                bPOLogisticsWithTax: buyerQuote.bQuotLogisticsWithTax,
                bPOlogisticsOption: buyerQuote.bQuoteLogisticsOption,
                bPOTotalAmountBeforeTax: buyerQuote.bQuotTotalItemAmountBeforeTax,
                bPOTotalAmountWithTax: buyerQuote.bQuotTotalItemAmountWithTax,
                bPOTotalTax: buyerQuote.bQuotTotalPOTax,
                totalPOAmount: buyerQuote.totalPOAmount,
                bPOlogisticsGSTRateOverride: buyerQuote.bQuotlogisticsGSTRateOverride,
                bPOLogisticsHSNCode: buyerQuote.bQuotLogisticsHSN,
                isURP: buyerQuote.isURP,
                pmCompanyId: relatedUserCompany?.pmCompanyId,
                // pmBranchId : relatedUserCompany?.branchId,
                pmBranchId: buyerQuote.pmBranchId,
                currency: buyerQuote.currency, 
                currencyRate: buyerQuote.currencyRate,
                paymentTerms: buyerQuote.paymentTerms,
                billAddrId: selectedBuyerBillAddrId,
                shipAddrId: selectedBuyerShipAddrId,
                pmBillAddrId: buyerQuote.pmBillAddrId,
                createdBy : usersData?.userId, 
                updatedBy : usersData?.userId
            }

            const calculatedResult = calculateBuyerPO(buyerPOData, newBuyerQuoteItems)
            let data = {
                buyerPo : calculatedResult.buyerPO,
                buyerPoItems : calculatedResult.buyerPOItems,
                prevBuyerPO : buyerPO,
                companyERPCodeMaps: updatedClientMaterials,
                companyERPCodeMapsWithRateContracts: updatedClientQtyMultiplierMaterials,
                buyerReq: buyerReq,
                isNewBillAddrIdSelected : selectedBuyerBillAddrId !== buyerQuote.billAddrId
            }
            
            if(isAllAreNotProducts){
                dispatch(raiseToast({severity:'warn', detail: "Shipping/Logistics Charges are included as products", life: 20000}))
            }
            
            const isCompanyERPCodeMissing = updatedClientMaterials.some(eachClientMaterial => !eachClientMaterial.companyERPCode)
            if (buyerBillAddrDetails[0].tags?.isERPCodeMandatory && isCompanyERPCodeMissing){

                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter Company ERP Code for the materials.", life: 3000 }))
            }

            const invalidClientMaterials = updatedClientMaterials.some((eachClientMaterial, index) => {
                if (eachClientMaterial.companyProdSpec?.trim()?.length < 3) {
                    dispatch(raiseToast({severity: 'error', detail: `Please add atleast 3 letters specification for material Id ${eachClientMaterial?.materialId}`, life: 3000}))
                    return true
                }
            })
            
            if(invalidClientMaterials) {
                return
            }

            setShowConfirmationStepper(true)
            setRaisePOData(data)
        }
        setIsLoadingVisible(false)
    }

    const handleApprovalRequest = (data) => {
        setApprovalInstances([...approvalInstances, data])
    }

    const handleSubmitMaterialConfirmModal = () => {
        if(!materialDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm materials and qty are correct', life: 3000}))
        }
        return true
    }

    const handleSubmitAddrandGSTINConfirmModal = () => {
        if(!addressAndGSTINDeclaration.billAddrDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm bill address', life: 3000}))
        }
        
        if(!addressAndGSTINDeclaration.shipAddrDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm ship address', life: 3000}))
        }

        if(!addressAndGSTINDeclaration.buyerGSTINDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm buyer GSTIN', life: 3000}))
        }

        if(!addressAndGSTINDeclaration.PMGSTINDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm procmart GSTIN', life: 3000}))
        }

        if(!addressAndGSTINDeclaration.paymentTermsDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please confirm buyer payment terms', life: 3000}))
        }

        return true
    }

    const handleQtyMultiplierConfirmModal = async () => {
        let isBuyerQuoteItemsWithQtyMultiplierExists = false
        if (raisePOData && raisePOData.buyerPoItems){
            isBuyerQuoteItemsWithQtyMultiplierExists = raisePOData?.buyerPoItems.some(eachBuyerPOItem => eachBuyerPOItem.companyQtyMultiplier && eachBuyerPOItem.companyQtyMultiplier > 1)
        }
        if (isBuyerQuoteItemsWithQtyMultiplierExists && !qtyMultiplierDeclaration){
            return dispatch(raiseToast({severity:'warn', detail: 'Please check and confirm qty multiplier values and proceed.', life: 3000}))
        }

        let windowMessage = "Do you want to continue to Raise PO?"
        if (buyerReq?.orderTypeId === 3){
            windowMessage = "Approvals are needed for the Buyer PO as it is a Stock PO. Do you want to continue to Raise PO?"
        }

        if (window.confirm(windowMessage)){
            setShowConfirmationStepper(false)
            setIsLoadingVisible(true)
            const response = await insertBuyerPO(raisePOData)
            if (response.failure){
                dispatch(raiseToast({severity:'error', summary: "Insert Buyer PO", detail:response.data.error, life: 3000}))
            }else{
                setMaterialDeclaration(false)
                setAddressAndGSTINDeclaration({})
                dispatch(raiseToast({severity: 'success', detail: "Buyer PO has Created", life: 3000}))
                const buyerPOId = response.data.buyerPO.buyerPOId
                navigate(`/buyerpo/${buyerPOId}`)
            }
        }
    }

    const handleRemarks = (srNo, text, prefillText) => {
        const updatedApprovalRequestStatusDetails = approvalRequestStatusDetails.map(eachRequestDetail => {
            if(eachRequestDetail.srNo === srNo){
                if([1].includes(eachRequestDetail.approvalTypeId)){
                    if (text.startsWith(prefillText)) {
                        return {...eachRequestDetail, remarks: text}
                    } else {
                        return {...eachRequestDetail, remarks: prefillText}
                    }
                } else {
                    return {...eachRequestDetail, remarks: text}
                }
            }
            return eachRequestDetail
        })

        setApprovalRequestStatusDetails(updatedApprovalRequestStatusDetails)
    }

    const handleSendMail = async (emailObj) => {
        let updatedEmailObj = {
            ...emailObj,
            useOrders: true,
            isPassRequirement,
            buyerCompany: buyerCompanyDetails
        }

        if(emailObj.kam){
            updatedEmailObj.cc = [...updatedEmailObj.cc, emailObj.kam]
        }
        
        const emailRes = await sendEmail(updatedEmailObj)
        if (emailRes?.failure){
            dispatch(raiseToast({severity:'error', summary: "Send Buyer Quote Mail", detail: emailRes?.data?.error, life: 3000}))
        }else{
            dispatch(raiseToast({severity:'success', detail: "Mail has been sent succesfully", life: 3000}))
        }
    }

    const updateBuyerQuoteState = (data) => {
        setBuyerQuote(data)
    }


    const raisePOFooterContent = () => {
        return(
            <div className="mt-2">
                <Button label="Cancel" severity="danger" outlined onClick={() => setVisibleRaisePO(false)} />
                <Button label="Raise PO" disabled={buyerQuote?.statusId !== 1 || isAllItemsPODone} permissions={[10]} outlined onClick={handleRaisePO}/>
            </div>
        )
    }

    const renderHTMLBuyerQuotation = (documentHTML) => {
        const sanitizedHTML = DOMPurify.sanitize(documentHTML)

        return(
            <div ref={documentRef} >
                {Parser(sanitizedHTML)}
            </div> 
        )
    }

    const renderBuyerQuotePDF = (buyerQuotePDFURL) => {
        return(
            <div className="doc-pdf-width" style={{width: '210mm'}}>
                {
                    buyerQuotePDFURL ?
                        <DocumentView fileUrl={buyerQuotePDFURL}/>
                        :
                        <p className="">Document not found!</p>
                }
            </div>
        )
    }

    const renderQuoteDetails = (buyerQuote) => {
        const createdByUser = usersData.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === buyerQuote.createdBy)
        const relatedPmBranch = usersData.PMCompanyDetails.companyBranches.find(eachBranch => eachBranch.branchId === buyerQuote.branchId)
        const pmBranchName = relatedPmBranch ? relatedPmBranch.branchName : ''
        return (
            <div className="flex align-items-center gap-2 p-2">
                <div className="flex align-items-center gap-1">
                    <span className="text-600 font-medium">Quote No:</span>
                </div>
                <div className="flex align-items-center gap-1">
                    <span 
                        className="text-primary font-bold cursor-pointer hover:text-primary-600 transition-colors transition-duration-200"
                        style={{ 
                            textDecoration: 'underline',
                            textUnderlineOffset: '2px'
                        }}
                        onClick={() => window.open(`/buyer/quotation/${buyerQuote.buyerQuoteId}`)}
                    >
                        {buyerQuote.docNo}
                    </span>
                    {buyerQuote.docNo && <CopyToClipboard text={buyerQuote.docNo} />}
                </div>
                <div className="flex align-items-center gap-1">
                    <span className="text-600">by</span>
                    <div className="bg-primary-50 px-2 py-1 border-round">
                        <PMUserName 
                            userName={getFullName(createdByUser.firstName, createdByUser.lastName)} 
                            userId={buyerQuote.createdBy} 
                        />
                    </div>
                </div>
                {pmBranchName && (
                    <div className="flex align-items-center gap-1">
                        <span className="text-500">(</span>
                        <span className="text-600 font-medium">{pmBranchName}</span>
                        <span className="text-500">)</span>
                    </div>
                )}
                <div className="flex align-items-center gap-1">
                    <span className="text-600">on</span>
                    <span className="bg-green-50 text-green-700 px-2 py-1 border-round font-medium">
                        {getDateString(buyerQuote.createdAt)}
                    </span>
                </div>
            </div>
        )
    }

    const renderTableStructure = () => {
        return (
            <div className={`p-card my-2 py-1 quotation-modal-data ${buyerQuote?.statusId === 6 ? 'cancelled-watermark' : ''}`}>
                <ConfirmPopup />
                <div className="grid">
                    <div className="flex flex-row col-12 justify-content-between pb-0">
                        <div className="flex flex-row justify-content-start align-items-center col-12 md:col-8 lg:col-8 lg:mb-0 pl-0">
                            {renderQuoteDetails(buyerQuote)}
                            {buyerQuote?.validUpto ? <span className="ml-4">Valid Upto: {getDateString(buyerQuote?.validUpto)}</span> : ""}
                        </div>
                        <div className="flex flex-row col-12 mb-2  md:col-4 lg:col-4 lg:mb-0 align-items-center justify-content-end pt-0">
                            <div className="flex justify-content-end mb-2 ml-2">
                                <Button className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${approvalIconColour}`} rounded onClick={() => setVisibleApprovals(true)} disabled={visiblePageLoading || !pendingApprovalsExist} >
                                    <i className={visiblePageLoading ? "pi pi-spin pi-spinner" : approvalsIcon} style={{ fontSize: "0.9rem", cursor: "pointer" }} />
                                </Button>
                            </div>
                            <div className="flex justify-content-end mb-2">
                                <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                                <Button className="ml-2" rounded onClick={(e) => actionMenu.current.toggle(e)} disabled={visiblePageLoading} >
                                    <i className={visiblePageLoading ? "pi pi-spin pi-spinner" : "pi pi-ellipsis-h"} style={{ fontSize: "0.9rem", cursor: "pointer" }} />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="custom-table-container">
                    <table className="custom-product-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="">
                                <th className="" >SR</th>
                                <th className="" >PRODUCT</th>
                                <th className="" >HSN/SAC</th>
                                <th className="" >DELIVERY PERIOD</th>
                                <th className="" >SPECIFICATION</th>
                                <th className="" >QUANTITY</th>
                                <th className="" >TOTAL AMOUNT</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            {
                                buyerQuoteItems?.map((eachBuyerQuoteItem, index) => {
                                    const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerQuoteItem?.materialId)
                                    const relatedBrand = brandData.find(eachBrand => eachBrand.brandId === relatedMaterial?.brandId)

                                    return (
                                        <tr className="" key={`buyerQuoteItem-${eachBuyerQuoteItem.buyerQuoteItemId}`} style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="" >{index + 1}</td>
                                            <td className="">{getProductName(relatedBrand?.brandName, relatedMaterial?.productName, relatedMaterial?.variantName)}</td>
                                            <td className="" >{eachBuyerQuoteItem?.bQuotHSNCode}</td>
                                            <td className="" >{eachBuyerQuoteItem?.leadTime} Day(s)</td>
                                            <td className="">{getProductSpecification(relatedMaterial?.productSpecification, relatedMaterial?.UOM, relatedMaterial?.UOMValue)}</td>
                                            <td className="" >{getProductQty(eachBuyerQuoteItem?.totReqQty, relatedMaterial?.UOM, relatedMaterial?.UOMValue)}</td>
                                            <td className="" >{numberConversion(eachBuyerQuoteItem?.bQuoteItemAmountWithTax, numberLocale)}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    const renderDocumentStructure = () => {
        return (
            <>
                <div style={{ width: "" }} className="flex flex-column md:flex-row md:justify-content-between document-page-container">
                    <h4 className="mt-2 mb-0">BUYER QUOTATION <span style={{fontSize: "14px", fontWeight: "normal"}}>{buyerReq?.buyerReqId && (buyerReq?.isRouted ? ` - ROUTED` : ` - NOT ROUTED`)}</span></h4> 
                    <div className="flex justify-content-end mt-2 md:mt-0">
                        <div className="flex justify-content-end mb-2 ml-2">
                            <Button className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${pendingApprovalsExist && "red-text"} ${allApprovalsApproved && "green-text"}`} label="Approvals" onClick={() => setVisibleApprovals(true)} disabled={!pendingApprovalsExist} />
                        </div>
                        <div className="flex justify-content-end mb-2">
                            <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                            <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ml-2" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                        </div>
                    </div>
                </div>
                <div className='document-y-scroll'>
                    {
                        buyerQuotePDFURL && !displayTable ? renderBuyerQuotePDF(buyerQuotePDFURL) : 
                        <div className={buyerQuote?.statusId === 6 && "cancelled-watermark"}>{renderHTMLBuyerQuotation(documentHTML)}</div>
                    }
                </div>
               
                <Loading visible={visiblePageLoading}/>
            </>
        )
    }

    const steps = [
        {
            header: 'Material Confirmation',
            content: (
                <div className="p-2" style={{minHeight: "340px"}}>
                   <MaterialConfirmDailogModal
                        raisePOData={raisePOData}
                        materialDetails={materialDetails}
                        buyerQuote={buyerQuote}
                        isAllItemsPODone={isAllItemsPODone}
                        materialDeclaration={materialDeclaration}
                        setMaterialDeclaration={setMaterialDeclaration}
                    /> 
                </div>
            ),
            onNext: handleSubmitMaterialConfirmModal
        },
        {
            header: 'Address and GST Confirmation',
            content: (
                <div className="px-3 py-2" style={{minHeight: "340px"}}>
                   <AddrAndGSTINConfirmDialog
                        raisePOData={raisePOData}
                        buyerBillAddrDetails={buyerBillAddrDetails}
                        buyerShipAddrDetails={buyerShipAddrDetails}
                        pmCompanyBillAddrDetails={pmCompanyBillAddrDetails}
                        stateList={stateList}
                        buyerQuote={buyerQuote}
                        isAllItemsPODone={isAllItemsPODone}
                        companyCreditPeriods={companyCreditPeriods}
                        addressAndGSTINDeclaration={addressAndGSTINDeclaration}
                        setAddressAndGSTINDeclaration={setAddressAndGSTINDeclaration}
                    />
                </div>
            ),
            onNext: handleSubmitAddrandGSTINConfirmModal
        }
    ]

    let isBuyerQuoteItemsWithQtyMultiplierExists = false
    if (raisePOData && raisePOData.buyerPoItems){
        isBuyerQuoteItemsWithQtyMultiplierExists = raisePOData?.buyerPoItems.some(eachBuyerPOItem => eachBuyerPOItem.companyQtyMultiplier && eachBuyerPOItem.companyQtyMultiplier > 1)
    }

    if (isBuyerQuoteItemsWithQtyMultiplierExists){
        steps.push(
            {
            header: 'Qty Multiplier Confirmation',
            content: (
                <div className="px-3 py-2" style={{minHeight: "340px"}}>
                   <QtyMultiplierConfirmDialog
                        raisePOData={raisePOData}
                        materialDetails={materialDetails}
                        qtyMultiplierDeclaration={qtyMultiplierDeclaration}
                        setQtyMultiplierDeclarataion={setQtyMultiplierDeclarataion}
                    />
                </div>
            ),
            }
        )
    }

    let approvalsIcon = 'pi pi-check'
    let approvalIconColour = "green-text"

    if (pendingApprovalsExist){
        approvalsIcon = "pi pi-hourglass"
        approvalIconColour = "yellow-text"
    }
    if (notRequestedApprovalExists){
        approvalsIcon = 'pi pi-times'
        approvalIconColour = "red-text"
    }
    if (allApprovalsApproved){
        approvalsIcon = "pi pi-check"
        approvalIconColour = "green-text"
    }


    return (
        <>
            {
                displayTable ? 
                renderTableStructure()
                :
                renderDocumentStructure()
            }
            <RemarksDialog visible={isReasonDialogVisible} onHide={() => setIsReasonDialogVisible(current => !current)} onSubmit={handleCancelBuyerQuote}/>
            <SendEmail emailDetailsObj={emailDetailsObj} handleSendMail={handleSendMail} visible={isEmailDialogVisible} onHide={() => setIsEmialDialogVisible(current => !current)}/>

            {isQuoteExpired && <Tooltip target="#quoteExpirationRaisePOTooltip" showOnDisable content="Quote is expired. Extend the validity of this quote to use." position="left" />}
            {isQuoteExpired && <Tooltip target="#quoteExpirationDownloadQuoteTooltip" showOnDisable content="Quote is expired. Extend the validity of this quote to use." position="left" />}
            <Dialog header="Approvals" className="approvals-dialog" visible={visibleApprovals} onHide={() => setVisibleApprovals(false)} style={{ width: '80vw',height: '80vh' }} >
                {/* <ApprovalDisplay 
                    buyerReqItems={buyerReqItems}
                    buyerQuote={buyerQuote}
                    buyerQuoteItems={buyerQuoteItems} 
                    approvalInstances={approvalInstances} 
                    handleApprovalRequest={handleApprovalRequest}
                    quotationApprovals={quotationApprovals} 
                    statusData={statusData} 
                    materialDetails={materialDetails} 
                    requiredApprovals={requiredApprovals}
                    approvalRequestStatusDetails={approvalRequestStatusDetails}
                    setApprovalRequestStatusDetails={setApprovalRequestStatusDetails}
                    brandData={brandData}
                    materialCategories={materialCategories}
                    handleRemarks={handleRemarks}
                    isDoc={true}
                    buyerQuoteId={buyerQuoteId}
                    buyerReq={buyerReq}
                    primaryApprovers={primaryApprovers}
                    approvalSecondary={approvalSecondary}
                /> */}
                <NewApprovalsDisplay 
                    buyerReqItems={buyerReqItems}
                    buyerQuote={buyerQuote}
                    buyerQuoteItems={buyerQuoteItems} 
                    approvalInstances={approvalInstances} 
                    handleApprovalRequest={handleApprovalRequest}
                    approvalTypes={approvalTypes}
                    quotationApprovals={quotationApprovals} 
                    statusData={statusData} 
                    materialDetails={materialDetails} 
                    approvalRequestStatusDetails={approvalRequestStatusDetails}
                    setApprovalRequestStatusDetails={setApprovalRequestStatusDetails}
                    brandData={brandData}
                    materialCategories={materialCategories}
                    handleRemarks={handleRemarks}
                    isDoc={true}
                    buyerQuoteId={buyerQuoteId}
                    buyerReq={buyerReq}
                    approvalSecondary={approvalSecondary}
                />
            </Dialog>

            <Dialog header="RAISE PO" className="" visible={visibleRaisePo} style={{ width: '95vw' }} onHide={() => setVisibleRaisePO(false)} footer={raisePOFooterContent}>
                <RaisePOModal
                    isLoadingVisible={isLoadingVisible} 
                    setIsLoadingVisible={setIsLoadingVisible}
                    isAllItemsPODone={isAllItemsPODone} 
                    buyerPO={buyerPO} 
                    buyerPOItems={buyerPOItems} 
                    materialDetails={materialDetails} 
                    selectedBuyerBillAddrId={selectedBuyerBillAddrId} 
                    setSelectedBuyerBillAddrId={setSelectedBuyerBillAddrId} 
                    selectedBuyerShipAddrId={selectedBuyerShipAddrId} 
                    setSelectedBuyerShipAddrId={setSelectedBuyerShipAddrId} 
                    buyerReq={buyerReq} 
                    buyerShipAddrDetails={buyerShipAddrDetails} 
                    pmCompanyBillAddrDetails={pmCompanyBillAddrDetails} 
                    buyerBillAddrDetails={buyerBillAddrDetails} 
                    buyerQuote={buyerQuote} 
                    raisedBuyerQuoteItems={raisedBuyerQuoteItems} 
                    selectedBuyerQuoteItems={selectedBuyerQuoteItems} 
                    handleBuyerPOItemChange={handleBuyerPOItemChange} 
                    handleCheckBoxClick={handleCheckBoxClick} 
                    handleSelectBuyerQuoteItems={handleSelectBuyerQuoteItems}
                    materialBrands={brandData}
                    materialUOMs={materialUOMs}
                    initialRaisedBuyerQuoteItems={initialRaisedBuyerQuoteItems}
                    buyerRateContracts={buyerRateContracts}
                    setraisedBuyerQuoteItems={setraisedBuyerQuoteItems}
                    setBuyerShipAddressDetails={setBuyerShipAddressDetails}
                    stateList={stateList}
                    pinCodes={pinCodes}
                    countriesData={countriesData}
                    userDetails={usersData}
                />
            </Dialog>

            <Dialog header="SELECT QUOTE LOST REASON" visible={isClosureReasonModalVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => {setIsClosureReasonModalVisible(false)}}>
                <div className="vendor-payment-summary-tab" style={{width: "100%", paddingLeft: "0%", paddingRight: "0%"}}>
                    <QuoteClosureReasonModal buyerQuote={buyerQuote} setIsClosureReasonModalVisible={setIsClosureReasonModalVisible} updateBuyerQuoteState={updateBuyerQuoteState} />
                </div>
            </Dialog>
            <Dialog header="Extend Quote Validity" visible={isExtendValidityDialogVisible} style={{ width: '40vw', height: '30vh' }} onHide={() => setIsExtendValidityDialogVisible(false)}>
                <ExtendValidityDialog setIsExtendValidityDialogVisible={setIsExtendValidityDialogVisible} buyerQuote={buyerQuote} setBuyerQuote={setBuyerQuote} setBuyerQuotePDFURL={setBuyerQuotePDFURL}/>
            </Dialog>
            <Dialog header="CONVERSION PROBABILITY" visible={isConversionProbabilityVisible} style={{ width: '40vw', minHeight: '30vh' }} onHide={() => {setIsConversionProbabilityVisible(false)}}>
                <div style={{width: "100%", paddingLeft: "0%", paddingRight: "0%"}}>
                    <ConversionProbabilityDialog buyerQuote={buyerQuote} setIsConversionProbabilityVisible={setIsConversionProbabilityVisible} updateBuyerQuoteState={updateBuyerQuoteState} />
                </div>
            </Dialog>

            {showConfirmationStepper && (
                <Dialog className="sub-dialog-of-raise-po-dialog" visible={showConfirmationStepper} style={{ maxHeight: "90vh", minHeight: "500px", width: "70vw" }} modal={true} onHide={() => setShowConfirmationStepper(false)}>
                    <Stepper
                        steps={steps} 
                        onSubmit={handleQtyMultiplierConfirmModal}
                    />
                </Dialog>
            )}
        </>
    )
}

export default BuyerQuoteView